// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jlfi","newExpiryDate":"styles_newExpiryDate__1yVyr","footer":"styles_footer__3FKw6"};